import i18next from 'app/lib/i18n/i18n';
import { useTranslation } from 'react-i18next';
import { TPaths } from 'app/lib/@types';
import en from './en.json';
import ru from './ru.json';

const componentsTranslationNs = 'components';

i18next.addResourceBundle('en', componentsTranslationNs, en);
i18next.addResourceBundle('ru', componentsTranslationNs, ru);

declare module 'i18next' {
  interface i18nResources {
    [componentsTranslationNs]: typeof en;
  }
  interface CustomTypeOptions {
    // custom namespace type if you changed it
    //defaultNS: typeof companiesPanelTranslationNs;
    // custom resources type
    resources: i18nResources;
  }
}

export type TComponentsTranslationPaths = TPaths<typeof en> &
  TPaths<typeof ru>;

export function useComponentsTranslations(): (
  key: TComponentsTranslationPaths,
  options?: Record<string, string | number>
) => string {
  const { t } = useTranslation(componentsTranslationNs);
  return t;
}
